import { useEffect, useState } from 'react';
import { useAuth as useOidcAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../config/env';

/**
 * OIDC redirect callback. react-oidc-context handles `signinCallback` for us
 * via the `OidcAuthProvider` (see `onSigninCallback` in `AuthProvider`). All
 * this screen needs to do is wait for the auth state to settle, then bounce
 * the user back to where they came from (stored on the OAuth `state` blob).
 */
export function AuthCallback() {
  const cfg = getConfig();

  // In fake mode, the auth callback should never be hit, but if it is just
  // bounce to the root.
  if (cfg.AUTH_MODE === 'fake') {
    return <FakeBounce />;
  }
  return <RealCallback />;
}

function FakeBounce() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);
  return null;
}

function RealCallback() {
  const oidc = useOidcAuth();
  const navigate = useNavigate();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (oidc.isLoading) return;
    if (oidc.error) {
      setShown(true);
      return;
    }
    if (oidc.isAuthenticated) {
      const state = oidc.user?.state as { returnTo?: string } | undefined;
      const returnTo = state?.returnTo ?? '/';
      navigate(returnTo, { replace: true });
    }
  }, [oidc.isLoading, oidc.isAuthenticated, oidc.error, oidc.user, navigate]);

  if (shown && oidc.error) {
    return (
      <div className="auth-error" style={{ padding: 32, fontFamily: 'Heebo, sans-serif' }}>
        <h1>שגיאת אימות</h1>
        <p>לא ניתן להשלים כניסה.</p>
        <pre style={{ whiteSpace: 'pre-wrap', color: '#b91c1c' }}>
          {oidc.error.message}
        </pre>
        <button type="button" onClick={() => navigate('/login', { replace: true })}>
          חזרה לכניסה
        </button>
      </div>
    );
  }
  return (
    <div style={{ padding: 32, fontFamily: 'Heebo, sans-serif' }}>
      <p>מאמת כניסה…</p>
    </div>
  );
}
